import { Component, OnInit, Input } from '@angular/core';
import { SetService, HttpService, PageService } from 'ngx-block-core';
import { selectSize, selectThemeSize, iconTheme } from "../../../data/data";

import { NzModalService, NzMessageService, NzNotificationService } from 'ng-zorro-antd';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-sucu05-button0010001',
    templateUrl: './sucu05-button0010001.component.html',
    styles: [``]
})
export class Sucu05Button0010001Component implements OnInit {

    @Input() local = false;
    @Input() static = false;
    @Input() blockid = "-1";
    @Input() layoutid = "-1";
    @Input() isVisible = false;
    @Input() sets = {
        blockCode: "sucublock12",
        blockId: "",
        blockName: "跳转按钮",
        layoutId: "",
        blockType: 'formButton',
        blockChildType: '',
        versionCode: 13,
        events: [
            {
                label: "隐藏",
                value: "pageShow",
                data: {
                    setParams: ["隐藏值", '显示值，可不填', '备用']
                }
            },
        ],
        styles: {
            nzText: "跳转",
            nzType: "default",
            nzSize: "default",
            nzBgColor: "",
            nzIcon: {
                nzIconType: '',
                nzIconTheme: '',
                nzIconColor: '',
            },
            nzOpen: true,
            nzShow: true,
            nzConfirm: {
                nzShow: false,
                nzTitle: "提示",
                nzContent: "确定吗？"
            },
            nzFocusMove: "",
            nzShape: null
        },
        datas: {
            nzDataSource: "",
            nzJumpType: "self",
            nzJumpPageType: 0,
            nzJumpPage: "",
            nzJumpMode: "none",
            nzJumpModalTitle: "",
            nzJumpModalWidth: 520,
            nzSenceSelectValue: [],
            nzSenceValue: [],
            nzVirtualSenceSelectValue: [],
            nzVirtualSenceValue: [],
            nzSenceJson: [],
            nzOtherFormCheck: [],
            nzProcedure: {
                nzProcedureIsNeed: false,
                nzProcedureTriggerPosition: "default",
                nzProcedureName: "",
                nzProcedureView: "",
                nzServiceParam: [],
                nzServiceParamDetail: { "sequ": 1 }

            },
            nzServiceParam: [],
            nzServiceParamDetail: { "sequ": 1 },
            nzOneSelfJump: false,
            jumpLog: '',
            nzValueSource: [],
            nzCloseValue: false,
            nzEvents: [

            ],
            nzEventsDatas: {
            },
        }
    };
    setData = []
    setDataInit() {
        let nzValueSourceAttributes = [
            {
                name: 'input',
                inputs: {
                    nzText: 'key',
                    nzKeys: ['key']
                },
                value: '',
                rule: ''
            },
            {
                name: 'select',
                inputs: {
                    nzText: '积木',
                    nzKeys: ['blockid'],
                    nzData: this.setService.getBlock('formBlock', "*")
                },
                value: '',
                rule: ''
            }
        ]
        this.setData = [
            {
                tabName: '数据',
                datas: [
                    {
                        type: 'datas',
                        data: [
                            { name: 'nzSceneValue', },
                            {
                                name: 'nzServiceParam',
                                inputs: { nzNeedUrlName: true, nzServiceParam: this.sets.datas.nzServiceParam, nzServiceParamDetail: this.sets.datas.nzServiceParamDetail }
                            },
                            { name: "nzOtherFormCheck" },
                        ]
                    }
                ]
            },
            {
                tabName: '操作',
                datas: [
                    {
                        type: 'datas',
                        data: [

                            { name: 'nzJumpPage', },
                            {
                                name: 'switch',
                                inputs: { nzText: "直接跳转 : ", nzKeys: ['datas', 'nzOneSelfJump'], nzPopContent: "直接跳转的情况下，不会获取表格值" }
                            },

                            { name: "nzDrawerLog", inputs: { nzType: "pop" } },
                            {
                                name: 'select',
                                inputs: { nzText: "焦点转移 : ", nzKeys: ['styles', 'nzFocusMove'], nzData: this.setService.getBlock('formBlock', "*") },
                            },
                            {
                                name: 'switch',
                                inputs: { nzText: "等待传值 : ", nzKeys: ['datas', 'nzCloseValue'], nzPopContent: ["开启后将等待弹框页面传值回来,并按照回调数据源分配"] }
                            },
                            {
                                name: 'list',
                                inputs: { nzText: "回调数据源 : ", titleKey: 'key', nzKeys: ['datas', 'nzValueSource'], attributes: nzValueSourceAttributes },

                            },
                            // { name: "nzEvents",inputs: { eventType: [{ value: 'dialog_close_value', label: '关闭传值' }] } },
                        ]
                    },
                ]
            },
            {
                tabName: '样式',
                datas: [
                    {
                        type: 'styles',
                        data: [
                            {
                                name: 'input',
                                inputs: { nzText: "积木名称 : ", nzKeys: ['blockName'] }
                            },
                            {
                                name: 'input',
                                inputs: {
                                    nzText: "按钮名称 : ", nzKeys: ['styles', 'nzText']
                                }
                            },
                            {

                                name: 'select',
                                inputs: {
                                    nzText: "主题 : ", nzKeys: ['styles', 'nzType'], nzData: selectThemeSize
                                }
                            },
                            {
                                name: 'radio',
                                inputs: { nzText: "图标主题:", nzKeys: ['styles', 'nzIcon', 'nzIconTheme'], nzData: iconTheme, },
                                outputs: {
                                    ngModelChange: (event) => {


                                        if (event == 'twotone') {

                                            this.setService.setDatas[this.blockid][2]['datas'][0]['data'][5]['show'] = true;

                                        } else {
                                            this.setService.setDatas[this.blockid][2]['datas'][0]['data'][5]['show'] = false;

                                        }


                                        this.setService.onReLoadbBlock(this.layoutid);

                                    }
                                }
                            },
                            {
                                name: 'input',
                                inputs: { nzText: "图标 : ", nzKeys: ['styles', 'nzIcon', 'nzIconType'], nzPopContent: ['填入type,请参照官方文档:', 'https://ng.ant.design/components/icon/zh'] },
                                outputs: { ngModelChange: () => { if (this.sets.styles.nzIcon.nzIconType == '') this.setService.onReLoadbBlock(this.layoutid) } }
                            },
                            {
                                name: 'color', show: this.sets.styles.nzIcon.nzIconType == 'twotone',
                                inputs: {
                                    nzText: "图标颜色 : ", nzKeys: ['styles', 'nzIcon', 'nzIconColor']
                                }
                            },

                            {
                                name: 'color',
                                inputs: {
                                    nzText: "背景颜色 : ", nzKeys: ['styles', 'nzBgColor']
                                }
                            },
                            {
                                name: 'radio',
                                inputs: { nzText: "大小 : ", nzKeys: ['styles', 'nzSize'], nzData: selectSize }
                            },
                            {
                                name: 'switch',
                                inputs: { nzText: "开放按钮 : ", nzKeys: ['styles', 'nzOpen'] }
                            },
                            {
                                name: 'radio',
                                inputs: { nzText: "形状 : ", nzKeys: ['styles', 'nzShape'], nzData: [{ value: null, label: '无' }, { value: 'circle', label: 'circle' }, { value: 'round', label: 'round' }] }
                            },

                            { name: 'nzConfirm' }
                        ]
                    },
                ]
            }, {
                tabName: '业务存储',
                datas: [
                    {
                        type: 'datas',
                        data: [

                            {
                                name: 'nzProcudure',
                                inputs: { nzProcedure: this.sets.datas.nzProcedure, nzServiceParam: this.sets.datas.nzProcedure.nzServiceParam, nzServiceParamDetail: this.sets.datas.nzProcedure.nzServiceParamDetail }
                            },
                            {
                                name: 'nzServiceParam',
                                inputs: { nzProcedure: this.sets.datas.nzProcedure, nzServiceParam: this.sets.datas.nzProcedure.nzServiceParam, nzServiceParamDetail: this.sets.datas.nzProcedure.nzServiceParamDetail, nzNeedProcedure: true }
                            },
                        ]
                    },
                ]
            },
        ]
    }



    constructor(
        public setService: SetService,
        private modalService: NzModalService,
        private httpService: HttpService,
        private pageService: PageService,
        private message: NzMessageService,
        private activatedRoute: ActivatedRoute

    ) { }
    ngOnInit() {


        if (!this.local) {//非本地
            if (!this.static) {//非静态
                if (this.setService.blocksort[this.blockid]['sets'] !== '{}') {
                    this.sets = this.setService.blocksort[this.blockid]['sets'];
                } else {
                    this.setService.blocksort[this.blockid]['sets'] = this.sets;
                }
                this.sets.blockId = this.blockid;
                this.sets.layoutId = this.layoutid;
                this.autoUpdate();
                this.setDataInit();
                if (typeof this.setService.setDatas[this.blockid] == 'undefined') {
                    this.setService.setDatas[this.blockid] = this.setData;
                }


            }
            else {//静态
                if (typeof this.sets == "string")
                    this.sets = JSON.parse(<any>this.sets);
                this.blockid = this.sets.blockId;
                this.layoutid = this.sets.layoutId;
                this.autoUpdate();
            }
        }
        this.Listening();

    }
    showModal(): void {
        this.isVisible = true;
    }

    handleOk(): void {
        console.log('Button ok clicked!');
        this.isVisible = false;
    }

    handleCancel(): void {
        console.log('Button cancel clicked!');
        this.isVisible = false;
    }

    onClick(): void {
        if (!this.sets.styles.nzOpen) {
            this.message.create('info', `功能暂未开放`);
        } else {
            this.clickTest();
        }

    }
    otherFormCheckStatus = {};
    otherFormCheckStatusMsgs = {};
    clickTest() {
        this.otherFormCheckStatus = {};
        this.otherFormCheckStatusMsgs = {};
        //其它校验
        console.log("其它校验do", this.sets.datas.nzOtherFormCheck)
        if (this.sets.datas.nzOtherFormCheck.length > 0) {
            this.pageService.pageDatas['formCheckDataStatu' + this.layoutid] = false;
            console.log("其它校验", 'formCheckDataStatu', this.layoutid)
            this.sets.datas.nzOtherFormCheck.forEach(element => {
                switch (element.type) {
                    case 'childTable':
                        this.otherFormCheckStatus[element.type] = false;
                        this.setService.sendEvent(element['datas']['blockid'], 'check_' + element.type, { blockid: this.blockid, num: element.datas.param0 })
                        break;
                    case 'hasTansfer':
                        this.otherFormCheckStatus[element.type] = false;
                        this.setService.sendEvent(element['datas']['blockid'], 'check_' + element.type, { blockid: this.blockid, num: element.datas.param0 })
                        break;
                    case 'hiddenvalue':
                        if (this.otherFormCheckStatus[element.type] === undefined) {
                            this.otherFormCheckStatus[element.type] = true;
                            this.otherFormCheckStatusMsgs[element.type] = [];
                        }

                        const formid = this.setService.pageDatas['form_data_' + this.layoutid].datas.nzForm.nzFormGroupDatas[element['datas']['blockid']]['nzKey'];
                        if (this.setService.pageDatas['form_' + this.layoutid].get(formid).value === '' || this.setService.pageDatas['form_' + this.layoutid].get(formid).value === null) {
                            this.otherFormCheckStatus['hiddenvalue'] = false;
                            if (element['datas']['param1'] !== '')
                                this.otherFormCheckStatusMsgs[element.type].push(element['datas']['param1']);
                        }

                        break;
                    default:
                        break;
                }
            });
            setTimeout(() => {
                let status = true;
                console.log('其它校验otherFormCheckStatus', this.otherFormCheckStatus, this.otherFormCheckStatusMsgs)
                for (let index = 0; index < this.sets.datas.nzOtherFormCheck.length; index++) {
                    const type = this.sets.datas.nzOtherFormCheck[index]['type'];
                    if (!this.otherFormCheckStatus[type]) {
                        status = false;

                        if (this.sets.datas.nzOtherFormCheck[index]['datas']['param1'] !== '') {
                            if (this.otherFormCheckStatusMsgs[type] === undefined)
                                this.message.error(this.sets.datas.nzOtherFormCheck[index]['datas']['param1']);
                            else {
                                if (this.otherFormCheckStatusMsgs[type].length >= 0) {
                                    this.otherFormCheckStatusMsgs[type].forEach(msg => {
                                        this.message.error(msg);
                                    });

                                }
                            }
                        }


                        break;

                    }
                }
                console.log("其它校验status", status)

                if (status) {
                    this.pageService.pageDatas['formCheckDataStatu' + this.layoutid] = true;
                    if (this.sets.styles.nzConfirm.nzShow) {
                        this.modalService.confirm({
                            nzTitle: this.sets.styles.nzConfirm.nzTitle,
                            nzContent: this.sets.styles.nzConfirm.nzContent,
                            nzOnOk: () => this.onClickEvents()
                        });
                    }
                    else {
                        this.onClickEvents();
                    }
                }

            }, 200);
        } else {
            this.onClickEvents();
        }
    }
    jumpPage(dateSets) {
        let queryParams = {};
        dateSets['nzServiceParam'].forEach(param => {
            queryParams[dateSets['nzServiceParamDetail'][param]['urlName']] = this.pageService.getServiceParam(dateSets['nzServiceParamDetail'][param], this.activatedRoute);
        });

        console.log("场景值组装完成", queryParams)
        if (!this.static) {//配置环境
            this.modalService.info({
                nzTitle: "提示",
                nzContent: "请前往生产环境测试"
            });


        } else {//生成环境


            this.pageService.goRouter(dateSets, queryParams, '', this.sets.datas['jumpLog']);

        }

    }
    async onClickEvents() {
        const datas = {
            "type": this.sets.datas.nzJumpType,
            "mode": this.sets.datas.nzJumpMode,
            "nzSenceJson": this.sets.datas.nzSenceJson,
            "pageRoute": this.sets.datas.nzJumpPage,
            "modalTitle": this.sets.datas.nzJumpModalTitle,
            "modalWidth": this.sets.datas.nzJumpModalWidth,
            "nzServiceParam": this.sets.datas.nzServiceParam,
            "nzServiceParamDetail": this.sets.datas.nzServiceParamDetail
        }
        // if (this.sets.datas.nzCloseValue) {
        //     datas.type = 'closeValue';
        //     this.setService.sendEvent(this.sets.datas.nzDataSource, "jumpPage", datas);
        // }
        // else 
        if (this.sets.datas.nzCloseValue) {
            datas['acceptBlockId'] = this.blockid;
            // if(this.setService.pageDatas['table_modal']===) this.setService.pageDatas['table_modal']={};
            // this.setService.pageDatas['table_modal']['acceptBlockId'] = this.blockid;
        }
        if (this.sets.datas.nzOneSelfJump == true) {
            this.jumpPage(datas);
        } else {
            if (this.sets.styles.nzFocusMove !== '') {
                this.setService.sendEvent(this.sets.styles.nzFocusMove, "focus", datas);
            }
            this.setService.sendEvent(this.sets.datas.nzDataSource, "jumpPage", datas);
        }



        //判断是否需要调用存储过程
        if (this.sets.datas.nzProcedure.nzProcedureIsNeed) {

            let serviceparams = this.pageService.getAllServiceParam(this.sets.datas['nzProcedure'], this.sets.datas['nzProcedure']['nzServiceParamDetail'], this.activatedRoute)
            console.log("获取业务参数1", serviceparams)
            serviceparams = await this.pageService.changeBodySn(serviceparams);
            console.log("获取业务参数2", serviceparams)
            let procedureParams = {
                dynamicSql: serviceparams[0].name,
                paramMap: serviceparams[0].compositeValue
            }

            console.log("获取处理业务参数", procedureParams)

            this.httpService.postHttp("/system/dynamicProcedure", procedureParams).subscribe(
                (data: any) => {
                    this.pageService.doAfterProcedure(data, this.sets);
                    console.log(data.data);
                });
        }
    }

    autoUpdate() {

        //v2,升级自定义表单参数
        if (this.sets.versionCode < 2) {

            this.sets.blockCode = "sucublock12";

            this.sets.versionCode = 2;
        }
        //v3,存储过程
        if (this.sets.versionCode < 3) {
            if (typeof this.sets.datas.nzProcedure == "undefined") {
                this.sets.datas['nzProcedure'] = {
                    nzProcedureIsNeed: false,
                    nzProcedureTriggerPosition: "default",
                    nzProcedureName: "",
                    nzProcedureView: "",
                    nzServiceParam: [],
                    nzServiceParamDetail: { "sequ": 1 }
                }
            }
            this.sets.versionCode = 3;
        }
        // V4 按钮开放
        if (this.sets.versionCode < 4) {

            this.sets.styles['nzOpen'] = true;

            this.sets.versionCode = 4;
        }
        // V5 按钮确认
        if (this.sets.versionCode < 5) {

            this.sets.styles['nzConfirm'] = {
                nzShow: false,
                nzTitle: "提示",
                nzContent: "确定要删除吗？"
            };

            this.sets.versionCode = 5;
        }
        // V6 按钮确认
        if (this.sets.versionCode < 6) {

            this.sets.datas['nzServiceParam'] = []
            this.sets.datas['nzServiceParamDetail'] = { "sequ": 1 }
            this.sets.datas['nzOneSelfJump'] = false;
            this.sets.versionCode = 6;
        }
        // V7 按钮开放
        if (this.sets.versionCode < 7) {

            this.sets.datas['nzOtherFormCheck'] = [];

            this.sets.versionCode = 7;
        }
        if (this.sets.versionCode < 8) {
            this.sets.datas['jumpLog'] = '';
            this.sets.versionCode = 8;
        }
        if (this.sets.versionCode < 11) {

            this.sets.styles['nzFocusMove'] = "";

            this.sets.versionCode = 11;
        }
        if (this.sets.versionCode < 12) {

            this.sets.datas['nzValueSource'] = [];
            this.sets.datas['nzEvents'] = [];
            this.sets.datas['datasnzEventsDatas'] = [];
            this.sets.datas['nzCloseValue'] = false;

            this.sets.versionCode = 12;
        }
        if (this.sets.versionCode < 13) {

            this.sets.events = [
                {
                    label: "隐藏",
                    value: "pageShow",
                    data: {
                        setParams: ["隐藏值", '显示值，可不填', '备用']
                    }
                },
            ]
            this.sets.styles['nzShow'] = true;
            this.sets.versionCode = 13;
        }


    }
    Listening() {
        setTimeout(() => {
            this.setService.initEvent(this.blockid);
            this.setService.events[this.blockid].subscribe(
                data => {
                    console.log("Listening-01:", data['type'], JSON.stringify(data));
                    let array0 = []
                    let array1 = []
                    switch (data['type']) {

                        case 'check_childTable_ans':
                            if (data.datas)
                                this.otherFormCheckStatus['childTable'] = true;

                            break;
                        case 'check_hasTansfer_ans':
                            if (data.datas)
                                this.otherFormCheckStatus['hasTansfer'] = true;

                            break;
                        case 'setValues':
                            this.sets.datas.nzValueSource.forEach(element => {
                                if (data.datas[element.key] !== undefined) {
                                    console.log('setValues', element, data.datas[element.key])
                                    this.setService.sendEvent(element.blockid, "linkagesetValue", { value: data.datas[element.key] })
                                }
                            });
                            break;
                        case 'pageShow':

                            console.log("data.datas.value", data.datas.value, data.datas.param0)
                            array0 = (data.datas.param0 + "").split(",");
                            array1 = (data.datas.param1 + "").split(",");
                            if (array0.indexOf(data.datas.value) >= 0) {
                                //disable
                                this.sets['styles']['nzShow'] = false;

                            } else if (array1.indexOf(data.datas.value) >= 0 || data.datas.param1 == "") {
                                // enable
                                this.sets['styles']['nzShow'] = true;
                                // this.form.get(this.nzFormGroupData.nzKey).enable();
                            }
                            break;

                        default:
                            break;
                    }
                }
            )
        }, !this.static ? 100 : 0);


    }

}
